import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useNavigate } from "react-router-dom";

export const CreateBot = ({ children }: { children: React.ReactNode }) => {
    const navigate = useNavigate();
    const [onOpen, setOnOpen] = useState(false);

    const [botName, setBotName] = useState("");
    const [botNameError, setBotNameError] = useState("");
    const [buttonDisabled, setButtonDisabled] = useState(true);

    useEffect(() => {
        if (botName.length === 0) {
            setBotNameError("");
            setButtonDisabled(true);
        } else if (botName.length > 20) {
            setBotNameError("Bot name must be less than 20 characters long");
            setButtonDisabled(true);
        } else {
            setBotNameError("");
            setButtonDisabled(false);
        }
    }, [botName]);

    const handleCreateBot = async () => {
        if (buttonDisabled) return;
        setButtonDisabled(true);
        const response = await fetch(`__SITE_BASE__/api/v1/bots`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                name: botName,
            }),
        });
        const json = await response.json();
        if (response.ok) {
            setOnOpen(false);
            navigate(`/developers/bots/${json.data.id}`);
        } else {
            setBotNameError(json.message);
            setButtonDisabled(false);
        }
    }

    return (
        <Dialog open={onOpen} onOpenChange={(onOpen) => setOnOpen(onOpen)}>
            <DialogTrigger>{children}</DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 ">
                <DialogHeader className="items-start justify-start">
                    <DialogTitle>Create Channel</DialogTitle>
                    <DialogDescription />
                </DialogHeader>

                {botNameError && <p className="text-red-500">{botNameError}</p>}
                <Label className="text-gray-300">Bot Name</Label>
                <Input
                    className="rounded-lg bg-brand-darkest border-r-0 border-l-0 border-t-0 border-b-brand-green placeholder:text-gray-300"
                    placeholder="Bot Name"
                    type="text"
                    value={botName}
                    autoComplete="false"
                    onChange={(e) => setBotName(e.target.value)}
                />                    


                <div className="flex items-end justify-end mt-2">
                    <Button
                        className="bg-brand-green px-5 py-2 rounded-lg text-white font-semibold hover:bg-green-500"
                        disabled={buttonDisabled}
                        onClick={handleCreateBot}
                    >
                        Create
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};
